(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etsy-pack-claim"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ff-etsy-claim').forEach(async (section) => {
    const status = section.querySelector('.ff-etsy-claim__status');
    const form = section.querySelector('.ff-etsy-claim__form');
    const submit = form.querySelector('button[type="submit"]');
    const reward = section.querySelector('.ff-etsy-claim__reward');
    const review = section.querySelector('.ff-etsy-claim__review');
    const reference = new URL(window.location.href).searchParams.get('ff_ref');
    if (!/^[A-Za-z0-9_-]{43}$/.test(reference || '')) {
      status.textContent = section.dataset.msgScan;
      return;
    }
    const proxy = `${section.dataset.proxyPath}?ff_ref=${encodeURIComponent(reference)}`;
    let nonce;
    const send = async (payload) => {
      const response = await fetch(proxy, { method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      return response.json();
    };
    const renewNonce = async () => {
      const response = await fetch(proxy, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (result.status !== 'order_verified' || !/^[A-Za-z0-9_-]{43}$/.test(result.claimNonce || ''))
        throw new Error('The order could not be refreshed.');
      nonce = result.claimNonce;
    };
    try {
      const response = await fetch(proxy, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (result.status === 'needs_review') {
        status.textContent = section.dataset.msgReview;
        return;
      }
      if (result.status !== 'order_verified' || !/^[A-Za-z0-9_-]{43}$/.test(result.claimNonce || '')) {
        status.textContent = section.dataset.msgUnavailable;
        return;
      }
      nonce = result.claimNonce;
      form.hidden = false;
      status.textContent = '';
    } catch {
      status.textContent = section.dataset.msgUnavailable;
      return;
    }
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      submit.disabled = true;
      status.textContent = section.dataset.msgSaving;
      const fields = new FormData(form);
      const pets = [1, 2, 3, 4].map((index) => String(fields.get(`pet_${index}`) || '').trim()).filter(Boolean);
      const favorite = form.querySelector('[name="favorite_treat"]');
      const payload = {
        action: 'submit',
        claimNonce: nonce,
        email: String(fields.get('email') || '').trim(),
        pets,
        favoriteTreat: favorite.value ? favorite.selectedOptions[0]?.textContent?.trim() : '',
        anythingElse: String(fields.get('anything_else') || '').trim(),
        marketingConsent: fields.get('marketing_consent') === 'yes'
      };
      try {
        let result;
        try { result = await send(payload); }
        catch {
          // The server may have completed the first write even if its response
          // was lost. The order-bound backend returns the same offer on retry.
          await renewNonce();
          payload.claimNonce = nonce;
          result = await send(payload);
        }
        if (result.status === 'refresh_required' || result.status === 'not_ready') {
          await renewNonce();
          payload.claimNonce = nonce;
          result = await send(payload);
        }
        if (result.status === 'offer_issued' && typeof result.code === 'string') {
          form.hidden = true;
          reward.hidden = false;
          reward.querySelector('.ff-etsy-claim__code').textContent = result.code;
          status.textContent = section.dataset.msgSaved;
        } else if (result.status === 'already_claimed') {
          form.hidden = true;
          review.hidden = false;
          status.textContent = section.dataset.msgAlreadyClaimed;
        } else if (result.status === 'profile_saved') {
          form.hidden = true;
          status.textContent = section.dataset.msgOfferPending;
        } else if (result.status === 'needs_review') {
          form.hidden = true;
          status.textContent = section.dataset.msgReview;
        } else {
          status.textContent = section.dataset.msgRetry;
          submit.disabled = false;
        }
      } catch {
        status.textContent = section.dataset.msgRetry;
        submit.disabled = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
